import React from 'react';
import { PreAuthNavbar } from '@/components/navigation/PreAuthNavbar';
import { RegisterForm } from '@/components/auth/RegisterForm';
import { Footer } from '@/components/marketing/Footer';

export const RegisterPage: React.FC = () => {
    return (
        <div className="min-h-screen flex flex-col">
            <PreAuthNavbar />
            <main className="flex-1 flex items-center justify-center px-4 py-12">
                <RegisterForm />
            </main>
            <Footer />
        </div>
    );
};

export default RegisterPage;
